import { useSelector } from 'react-redux'

import { getAuthIsLTSupervisor, getAuthSupervisorSelectedProviderId } from '../../../../data/auth/authSelectors'
import { ExtractRTKQueryArgs, RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { useGetClientsInProgramQuery } from '../ltClientsApi'

export const useClientsInProgramData: RTKQueryHook<typeof useGetClientsInProgramQuery> = (args, opts) => {
  const isSupervisor = useSelector(getAuthIsLTSupervisor)
  const supervisorSelectedProviderId = useSelector(getAuthSupervisorSelectedProviderId)

  return useGetClientsInProgramQuery(
    {
      ...args,
      providerId:
        isSupervisor && args?.interactionMode === 'interacted_with' ? supervisorSelectedProviderId : undefined,
    } as ExtractRTKQueryArgs<typeof useGetClientsInProgramQuery>,
    opts,
  ) as RTKQueryResultType<typeof useGetClientsInProgramQuery>
}
